export const TIMEQUICKFILTER_CUSTOM = 'TIMEQUICKFILTER_CUSTOM';
export const TIMEQUICKFILTER_24HOURS = 'TIMEQUICKFILTER_24HOURS';
export const TIMEQUICKFILTER_7DAYS = 'TIMEQUICKFILTER_7DAYS';
export const TIMEQUICKFILTER_THISMONTH = 'TIMEQUICKFILTER_THISMONTH';
export const TIMEQUICKFILTER_LASTMONTH = 'TIMEQUICKFILTER_LASTMONTH';
